import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/** A router wrapper, adding extra functions. */
@Injectable()
export class UrlService {
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(
    null
  );
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  constructor() {}

  setPreviousUrl(previousUrl: string) {
    this.previousUrl.next(previousUrl);
  }
}
